import React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import BannerGroups from './BannerGroups'
import BannerList from './Viewer'
import BannerEditor from './Editor'
import { PageNotFound } from 'components/Shared/ErrorPage'

export enum APP_MANAGER_VIEW_TYPE {
    BANNERS = 0,
}

const Banners: React.FC<RouteComponentProps> = ({ match }) => {
    const prefix = match.path
    return (
        <Switch>
            <Route path={`${prefix}/bannerGroups`} component={BannerGroups} />
            <Route exact path={`${prefix}/bannerList`} component={BannerList} />
            <Route exact path={`${prefix}/editBanner`} component={BannerEditor} />
            <Route path="*" component={PageNotFound} />
        </Switch>
    )
}

export default Banners
